import { render } from "./app-button-menu.vue?vue&type=template&id=7e31c000"
import script from "./app-button-menu.vue?vue&type=script&lang=js"
export * from "./app-button-menu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/button/app-button-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e31c000"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e31c000', __exports__)) {
    console.log('reload')
    api.reload('7e31c000', __exports__)
  }
  
  module.hot.accept("./app-button-menu.vue?vue&type=template&id=7e31c000", () => {
    console.log('re-render')
    api.rerender('7e31c000', render)
  })

}


export default __exports__